<template>
  <v-card class="mt-4">
    <v-card-text style="max-height: 500px; background-color: white">
      <!-- background: linear-gradient(70deg, #153a5f, #00abc0); -->
      <v-container v-if="loading">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-container>

      <bar-chart
        :chart-data="dataCollection"
        :chart-options="options"
      ></bar-chart>
    </v-card-text>
  </v-card>
</template>

<script>
import BarChart from "./BarChart2.vue";
export default {
  name: "chart-card",
  components: {
    BarChart,
  },
  props: [
    "datalogs",
    "max",
    "min",
    "label",
    "chartType",
    "chartPeriod",
    "detailsPath",
    "loading",
  ],
  data() {
    return {
      dataCollection: null,
      options: null,
      sum: 0,
      average: 0,
    };
  },
  watch: {
    // whenever question changes, this function will run
    datalogs(newDatalogs, oldDataLogs) {
      this.updateChartCollection(newDatalogs);
    },
  },
  mounted() {},
  methods: {
    goTo(detailsPath) {
      this.$router.push(detailsPath);
    },
    updateChartCollection(datalogs) {
      average =
        datalogs.reduce(function (acc, val) {
          return acc + val.value;
        }, 0) / datalogs.length;

      datalogs = datalogs.filter((el) => el.value < average * 5);

      var sum = datalogs.reduce(function (acc, val) {
        return acc + val.value;
      }, 0);
      this.sum = sum;

      var average = sum / datalogs.length;

      this.average = average;

      var dataCollection = {
        datasets: [
          {
            lineTension: 0,
            label: "2023",
            fontColor: "#015384",
            backgroundColor: "#015384",
            borderColor: "#015384",
            pointBackgroundColor: "#015384",
            fill: false,
            data: [],
          },

          {
            lineTension: 0,
            label: "2022",
            fontColor: "#08b4ec",
            backgroundColor: "#08b4ec",
            borderColor: "#08b4ec",
            pointBackgroundColor: "#08b4ec",
            fill: false,
            data: [],
          },
        ],
      };

      var options = {
        responsive: true,
        maintainAspectRatio: false,
        color: "#015384",
        scales: {
          x: {
            type: "time",
            ticks: { color: "#015384" },
            time: {
              unit: "month",
            },
          },
          y: {
            ticks: { color: "#015384" },
          },
        },
        plugins: {
          datalabels: {
            formatter: (value, ctx) => {
              let sum = 0;
              let dataArr = ctx.chart.data.datasets[0].data;
              dataArr.map((data) => {
                sum += data;
              });
              let percentage = ((value * 100) / sum).toFixed(2) + "%";
              return percentage;
            },
            color: "#000",
          },
          legend: {
            position: "top",
            fontColor: "#015384",

            color: "#015384",
          },
        },
      };

      if (this.max) options.scales.yAxes[0].ticks.max = parseFloat(this.max);
      if (this.min) options.scales.yAxes[0].ticks.min = parseFloat(this.min);

      for (var a = 0; a < datalogs.length; a++) {
        dataCollection.datasets[0].data.push({
          x: new Date(datalogs[a].createdAt),
          y: datalogs[a].value,
        });

        dataCollection.datasets[1].data.push({
          x: new Date(datalogs[a].createdAt),
          y: datalogs[a].value,
        });
      }
      this.dataCollection = dataCollection;
      this.options = options;
      this.$forceUpdate();
    },
  },
};
</script>

<style scoped></style>
